import { useState, FC } from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';

import { AInitialData } from 'store/init';
import { AAvailableContent, AProfile } from 'store/config';

import gameManager from 'api/gameManager/GameManager';

import Icon from 'shared/components/Icon';

import Avatars from './Avatars';
import {
  SWrapper,
  SMarker,
  SHeader,
  STitleWrapper,
  SUserTitle,
  SIconWrapper,
  SAvatarImg,
  SEditButton,
  SActionBtn,
  SToggleWrapper,
  SToggle,
  SHeaderWrapper,
} from './style';
import { IProfileProps } from './types';

const Profile: FC<IProfileProps> = () => {
  const { t } = useTranslation();
  const {
    chat: { rp, aka: userName, al },
  } = useRecoilValue(AInitialData);
  const { isIncognitoMode } = useRecoilValue(AProfile);
  const acl = useRecoilValue(AAvailableContent);

  const [isOpenAvatar, setIsOpenAvatar] = useState<boolean>(false);

  const editAvatar = () => {
    setIsOpenAvatar(true);
  };

  const closeAvatar = () => {
    setIsOpenAvatar(false);
  };

  const handleToLobby = () => {
    gameManager.navigateToLobbyURL();
  };

  const handleIncognitoMode = () => {
    gameManager.toggleIncognitoMode();
  };

  return (
    <SWrapper>
      <SMarker>{t('you')}</SMarker>
      <SHeader>
        <SHeaderWrapper>
          <SUserTitle>{userName || ''}</SUserTitle>
          <SIconWrapper>
            {al ? <SAvatarImg src={al} /> : <Icon name="ic_chatavatar" />}
            {rp && (
              <SEditButton onClick={editAvatar} title={t('changeAvatar')}>
                <Icon name="ic_edit" />
              </SEditButton>
            )}
          </SIconWrapper>{' '}
        </SHeaderWrapper>
      </SHeader>

      {gameManager.showLobbyBtn() && (
        <STitleWrapper>
          <SActionBtn onClick={handleToLobby}>{t('toLobby')}</SActionBtn>
        </STitleWrapper>
      )}

      {acl.includes('incog') && (
        <SToggleWrapper>
          <SToggle isActive={isIncognitoMode} onClick={handleIncognitoMode}>
            {`${t('incognitoModeTitle')}: ${t(isIncognitoMode ? 'on' : 'off')}`}
          </SToggle>
          <span>{t('incognitoModeText')}</span>
        </SToggleWrapper>
      )}

      {isOpenAvatar && <Avatars onClose={closeAvatar} />}
    </SWrapper>
  );
};

export default Profile;
